import { createSelector } from 'reselect';

export const selectImeiCheckStatus = state => state.imeiCheck;

export const makeSelectImeiCheckStatus = () =>
  createSelector(
    selectImeiCheckStatus,
    data => data.imeiMessage,
  );
